export enum ProfileNoteModalMode {
	CREATE = 'create',
	EDIT = 'edit',
}

export interface ProfileNoteModalProps {
	open: boolean;
	mode: ProfileNoteModalMode;
	workerId: string;
	initialContent?: string;
	noteId?: string;
	onSuccess?: () => void;
	onOptimistic?: {
		update?: (content: string) => void;
		rollback?: () => void;
	};
}
